import { autoinject } from 'aurelia-framework';
import { IImportAM, ImportService } from './import-api';

@autoinject
export class DashboardImportList {
	importEntries: IImportAM[];

	constructor(private importService: ImportService) {
	}

	async attached() {
		this.importEntries = await this.importService.getImports('staged');
	}
}
